import React from 'react';
import { useHistory } from 'react-router-dom';
import { Notification, Button } from '@vwfs-bronson/bronson-react';
import { NotificationStatus } from '../notification';

export type NotificationWithNavigationButtonProps = {
    status?: NotificationStatus;
    headline?: string;
    notificationTestId?: string;
    submitButtonLabel: string;
    pathToNavigate: string;
    className?: string;
    children?: React.ReactNode;
};

export const NotificationWithNavigationButton: React.FC<NotificationWithNavigationButtonProps> = ({
    status,
    headline,
    notificationTestId = 'notificationWithNavButton',
    submitButtonLabel,
    pathToNavigate,
    className,
    children,
}) => {
    const history = useHistory();
    const handleClick = () => history.push(pathToNavigate);
    return (
        <Notification
            className={className}
            visible
            showCloseButton={false}
            status={status}
            title={headline || ''}
            testId={notificationTestId}
        >
            {children}
            <Button secondary className="u-bg-white u-mt" testId="submitButton" onClick={handleClick}>
                {submitButtonLabel}
            </Button>
        </Notification>
    );
};
